import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import {
  Grid,
  TextField,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  FormControlLabel,
  Checkbox,
  InputAdornment,
} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import DeleteIcon from "@mui/icons-material/Delete";
import Autogooglecomplete from "./Autogooglecomplete";
import { useSelector } from "react-redux";
import { selectnodess } from "../redux/nodesSlice";
import Autocomplete from "@mui/material/Autocomplete";
import ReactQuill from "react-quill"; // Import React Quill
import "react-quill/dist/quill.snow.css"; // Import the styles for the editor
import { selectgroups } from "../redux/businessSlice";
import AddAdditionalFields from "./AddAdditionalField";
import { currencydata } from "../utils/currency";
import { NumericFormat } from "react-number-format";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 800,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
  overflow: "auto",
  maxHeight: "90vh",
};

export function AddChildNode({
  origin,
  nodeData,
  handleClose,
  open,
  handleChange,
  errors,
  handleSubmit,
  handelDirector,
  handleShareHolders,
  handelAddShareHolder,
  handleAddDirector,
  handleTotalSharesChange,
  enrichedOrganizations,
  allorganization1,
  setSharedata,
  sharedata,
  setNodeData,
  deleteJoint,
  handleJointChange,
  handleCheckbox,
  handleAddShareCompany,
}) {
  const allorganization = useSelector(selectnodess) || [];
  const [parentOptions, setParentOptions] = useState([]);
  const [parent, setParent] = useState([]);
  const [childerns, setchilderns] = useState([]);
  const [newdata, setnewdata] = useState([]);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const groups = useSelector(selectgroups);

  useEffect(() => {
    const mainorganization = Array.isArray(allorganization) && allorganization.filter(
      (item) => item.isBranch === false
    );
    const parents = mainorganization?.map((org) => {
      return {
        label: org.data.label,
        value: org.id.toString(),
      };
    });
    setParentOptions(parents);
  }, [allorganization]);

  useEffect(() => {
    const data = enrichedOrganizations?.find(
      (item) => item.id === nodeData.nodeId
    );
    setchilderns(data);
  }, [enrichedOrganizations]);

  useEffect(() => {
    const data = enrichedOrganizations?.find(
      (item) => item.id === nodeData.nodeId
    );
    setchilderns(data);
  }, [enrichedOrganizations, childerns]);

  const deleteDirectors = (index) => {
    setNodeData((prev) => ({
      ...prev,
      directors: prev.directors.filter((_, i) => i !== index),
    }));
  };

  useEffect(() => {
    const newCombinedData = childerns?.data?.shareHolders?.map(
      (shareholder) => {
        const enrichedOrg = allorganization1.find(
          (org) => org.id === shareholder.childId
        );
        return {
          ...shareholder,
          companyName: enrichedOrg
            ? enrichedOrg.data.companyName
            : "Unknown Company",
        };
      }
    );
    setnewdata(newCombinedData);
  }, [allorganization1, childerns]);
  useEffect(() => {
    const totalShareholdersShares = nodeData.shareHolders.reduce(
      (acc, item) => acc + parseFloat(item.numberSharesOwned || 0),
      0
    );
    const totalJointVentureShares = nodeData.JointVentureCompanies.reduce(
      (acc, item) => acc + parseFloat(item.numberSharesOwned || 0),
      0
    );

    // Remaining shares available to distribute
    const remainingShares =
      nodeData.totalNoOfShares -
      (totalShareholdersShares + totalJointVentureShares);
    setSharedata(remainingShares); // Updates the remaining shares count
  }, [nodeData]);
  // useEffect(() => {
  //   const total = nodeData.shareHolders.reduce((acc, item) => acc + parseFloat(item.numberSharesOwned || 0), 0);
  //   setSharedata(nodeData.totalNoOfShares - total);
  // }, [nodeData]);
  const deleteShareholder = (index) => {
    setNodeData((prev) => ({
      ...prev,
      shareHolders: prev.shareHolders.filter((_, i) => i !== index),
    }));
  };
  const handleShareHolderChange = (index, field, value) => {
    let updatedShareHolders = [...nodeData.shareHolders];
    updatedShareHolders[index] = {
      ...updatedShareHolders[index],
      [field]: value,
    };

    if (field === "numberSharesOwned" && nodeData.totalNoOfShares > 0) {
      updatedShareHolders[index].PercentageOfShares =
        (value / nodeData.totalNoOfShares) * 100;
    }
    if (
      field === "numberofpreferenceshares" &&
      nodeData.totalIssuedPreferenceShares > 0
    ) {
      updatedShareHolders[index].percentageofpreferanceshares =
        (value / nodeData.totalIssuedPreferenceShares) * 100;
    }

    setNodeData((prev) => ({ ...prev, shareHolders: updatedShareHolders }));
  };

  useEffect(() => {
    const data = parentOptions.filter(
      (item) => item.label !== nodeData.companyName
    );
    setParent(data);
  }, [parentOptions]);

  const handleCancel = () => {
    setShowWarningModal(true);
  };

  const handleRemarksChange = (value) => {
    setNodeData((prevData) => ({
      ...prevData,
      Remarks: value, // Update Remarks in state
    }));
  };

  const handleConfirmClose = () => {
    setShowWarningModal(false);
    handleClose();
  };

  const handleCheckboxChange = (event) => {
    setNodeData({
      ...nodeData,
      isOperatingCompany: event.target.checked,
    });
  };
  // console.log(nodeData, "this is node data");

  const handleCheck = (event) => {
    setNodeData({
      ...nodeData,
      checked: true,
      [event.target.name]: event.target.checked, // Set checked to true on click
    });
  };

  const handleTotalChange = (e) => {
    const { value } = e.target;
    const totalShares = parseFloat(value);
    // console.log(totalShares, "this is vqz")

    setNodeData((prevData) => {
      // console.log(prevData.shareHolders,"this is data")
      const updatedShareHolders = prevData.shareHolders?.map((shareHolder) => ({
        ...shareHolder,
        percentageofpreferanceshares:
          totalShares > 0
            ? (shareHolder?.numberofpreferenceshares * 100) / totalShares
            : 0,
      }));

      return {
        ...prevData,
        totalIssuedPreferenceShares: totalShares,
        shareHolders: updatedShareHolders,
      };
    });
  };

  return (
    <React.Fragment>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
        BackdropProps={{
          style: { zIndex: 0 },
        }}
        sx={{ zIndex: 1000 }}
      >
        <Box className="shadow border rounded" sx={style}>
          {/* <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton> */}

          <Grid container spacing={2} sx={{ p: 3 }}>
            <Grid container item xs={12} sm={6} spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="Company Name 2"
                  name="companyName"
                  id="outlined-basic"
                  value={nodeData.companyName}
                  onChange={handleChange}
                  error={Boolean(errors.general.companyName)}
                  fullWidth
                  helperText={errors.general.companyName}
                  variant="outlined"
                  size="small"
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Business Nature"
                  name="BusinessNature"
                  value={nodeData.BusinessNature}
                  onChange={handleChange}
                  error={Boolean(errors.general.BusinessNature)}
                  fullWidth
                  helperText={errors.general.BusinessNature}
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={12}>
                <Autogooglecomplete
                  setNodeData={setNodeData}
                  errors={errors}
                  nodeData={nodeData}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Incorporation Date"
                  type="date"
                  name="Incorporationdate"
                  id="outlined-basic"
                  value={nodeData.Incorporationdate}
                  onChange={handleChange}
                  error={Boolean(errors.general.Incorporationdate)}
                  fullWidth
                  helperText={errors.general.Incorporationdate}
                  variant="outlined"
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Company Registration Number"
                  name="CompanyRegistrationNumber"
                  id="outlined-basic"
                  value={nodeData.CompanyRegistrationNumber}
                  onChange={handleChange}
                  error={Boolean(errors.general.CompanyRegistrationNumber)}
                  fullWidth
                  helperText={errors.general.CompanyRegistrationNumber}
                  variant="outlined"
                  size="small"
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Business Registration Number"
                  name="BusinessRegistrationNumber"
                  id="outlined-basic"
                  value={nodeData.BusinessRegistrationNumber}
                  onChange={handleChange}
                  error={Boolean(errors.general.BusinessRegistrationNumber)}
                  fullWidth
                  helperText={errors.general.BusinessRegistrationNumber}
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={12}>
                <NumericFormat
                  value={nodeData.TotalPaidUpCapital}
                  thousandSeparator
                  customInput={TextField}
                  label="Registered/Issued Paid-up Capital"
                  name="TotalPaidUpCapital"
                  size="small"
                  variant="outlined"
                  fullWidth
                  helperText={errors.general.TotalPaidUpCapital}
                  error={Boolean(errors.general.TotalPaidUpCapital)}
                  onValueChange={(values) => {
                    handleChange({
                      target: {
                        name: "TotalPaidUpCapital",
                        value: values.value,
                      },
                    });
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <TextField
                          select
                          name="registerCurrency"
                          value={nodeData.registerCurrency}
                          onChange={handleChange}
                          variant="standard"
                          style={{ width: 70 }}
                          SelectProps={{
                            MenuProps: {
                              PaperProps: {
                                style: {
                                  maxHeight: 250,
                                  overflowY: "auto",
                                },
                                sx: {
                                  "& .MuiMenuItem-root": {
                                    color: "black",
                                  },
                                  "& ::-webkit-scrollbar": {
                                    width: "8px",
                                  },
                                  "& ::-webkit-scrollbar-track": {
                                    backgroundColor: "#9b2626ff",
                                    borderRadius: "4px",
                                  },
                                  "& ::-webkit-scrollbar-thumb": {
                                    backgroundColor: "#02070cff",
                                    borderRadius: "4px",
                                  },
                                  "& ::-webkit-scrollbar-thumb:hover": {
                                    backgroundColor: "#1565c0",
                                  },
                                },
                              },
                            },
                          }}
                        >
                          {currencydata?.map((currency) => (
                            <MenuItem key={currency} value={currency}>
                              {currency}
                            </MenuItem>
                          ))}
                        </TextField>
                      </InputAdornment>
                    ),
                  }}
                  isAllowed={(values) => {
                    const { floatValue } = values;
                    return floatValue >= 0 || floatValue === undefined;
                  }}
                // onBlur={handleSave} // Save on blur (optional)
                />
              </Grid>

              {origin !== "root" && (
                <>
                  <Grid item xs={12}>
                    <NumericFormat
                      value={nodeData.ParValueofShares}
                      thousandSeparator
                      customInput={TextField}
                      label="Par Value of Shares"
                      name="ParValueofShares"
                      size="small"
                      variant="outlined"
                      fullWidth
                      error={Boolean(errors.general.ParValueofShares)}
                      helperText={errors.general.ParValueofShares}
                      onValueChange={(values) => {
                        handleChange({
                          target: {
                            name: "ParValueofShares",
                            value: values.value,
                          },
                        });
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <TextField
                              select
                              onChange={handleChange}
                              value={nodeData.ParCurrency}
                              name="ParCurrency"
                              variant="standard"
                              style={{ width: 70 }}
                              SelectProps={{
                                MenuProps: {
                                  PaperProps: {
                                    style: {
                                      maxHeight: 250,
                                      overflowY: "auto", // Enable vertical scrolling
                                    },
                                  },
                                },
                              }}
                            >
                              {currencydata?.map((currency) => (
                                <MenuItem key={currency} value={currency}>
                                  {currency}
                                </MenuItem>
                              ))}
                            </TextField>
                          </InputAdornment>
                        ),
                      }}
                      isAllowed={(values) => {
                        const { floatValue } = values;
                        return floatValue >= 0 || floatValue === undefined;
                      }}
                    // onBlur={handleSave} // Save on blur (optional)
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <NumericFormat
                      value={nodeData.AuthorizedCapital}
                      thousandSeparator
                      customInput={TextField}
                      label="Authorized Capital"
                      name="AuthorizedCapital"
                      id="outlined-basic"
                      error={Boolean(errors.general.AuthorizedCapital)}
                      fullWidth
                      helperText={errors.general.AuthorizedCapital}
                      variant="outlined"
                      size="small"
                      onValueChange={(values) => {
                        handleChange({
                          target: {
                            name: "AuthorizedCapital",
                            value: values.value,
                          },
                        });
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <TextField
                              select
                              name="CapitalCurrency"
                              onChange={handleChange}
                              value={nodeData.CapitalCurrency}
                              variant="standard"
                              style={{ width: 70 }}
                              SelectProps={{
                                MenuProps: {
                                  PaperProps: {
                                    style: {
                                      maxHeight: 250,
                                      overflowY: "auto",
                                      scrollbarColor: "blue", // Enable vertical scrolling
                                    },
                                  },
                                },
                              }}
                            >
                              {currencydata?.map((currency) => (
                                <MenuItem key={currency} value={currency}>
                                  {currency}
                                </MenuItem>
                              ))}
                            </TextField>
                          </InputAdornment>
                        ),
                      }}
                      isAllowed={(values) => {
                        const { floatValue } = values;
                        return floatValue >= 0 || floatValue === undefined;
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <NumericFormat
                      value={nodeData.TotalPaidUpPremiumtoShares}
                      thousandSeparator
                      customInput={TextField}
                      label="Total Paid Up Premium to Shares/Share Premium"
                      name="TotalPaidUpPremiumtoShares"
                      size="small"
                      variant="outlined"
                      fullWidth
                      error={Boolean(errors.general.TotalPaidUpPremiumtoShares)}
                      helperText={errors.general.TotalPaidUpPremiumtoShares}
                      onValueChange={(values) => {
                        handleChange({
                          target: {
                            name: "TotalPaidUpPremiumtoShares",
                            value: values.value,
                          },
                        });
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <TextField
                              select
                              name="TotalCurrency"
                              variant="standard"
                              value={nodeData.TotalCurrency}
                              onChange={handleChange}
                              style={{ width: 70 }}
                              SelectProps={{
                                MenuProps: {
                                  PaperProps: {
                                    style: {
                                      maxHeight: 250,
                                      overflowY: "auto", // Enable vertical scrolling
                                    },
                                  },
                                },
                              }}
                            >
                              {currencydata?.map((currency) => (
                                <MenuItem key={currency} value={currency}>
                                  {currency}
                                </MenuItem>
                              ))}
                            </TextField>
                          </InputAdornment>
                        ),
                      }}
                      isAllowed={(values) => {
                        const { floatValue } = values;
                        return floatValue >= 0 || floatValue === undefined;
                      }}
                    // onBlur={handleSave} // Save on blur (optional)
                    />
                  </Grid>
                </>
              )}

              <Grid item xs={12}>
                <NumericFormat
                  value={nodeData.totalNoOfShares}
                  thousandSeparator
                  customInput={TextField}
                  label="Total Issued Ordinary Shares"
                  variant="outlined"
                  name="totalNoOfShares"
                  fullWidth
                  error={Boolean(errors.general.totalNoOfShares)}
                  helperText={errors.general.totalNoOfShares}
                  size="small"
                  onValueChange={(values) => {
                    handleTotalSharesChange({
                      target: {
                        name: "totalNoOfShares",
                        value: values.value,
                      },
                    });
                  }}
                  isAllowed={(values) => {
                    const { floatValue } = values;
                    return floatValue >= 0 || floatValue === undefined;
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <NumericFormat
                  value={nodeData?.totalIssuedPreferenceShares}
                  thousandSeparator
                  customInput={TextField}
                  label="Total Issued Preference Shares"
                  variant="outlined"
                  name="totalIssuedPreferenceShares"
                  size="small"
                  fullWidth
                  error={Boolean(errors.general.totalIssuedPreferenceShares)}
                  helperText={errors.general.totalIssuedPreferenceShares}
                  onValueChange={(values) => {
                    handleTotalChange({
                      target: {
                        name: "totalIssuedPreferenceShares",
                        value: values.value,
                      },
                    });
                  }}
                  isAllowed={(values) => {
                    const { floatValue } = values;
                    return floatValue >= 0 || floatValue === undefined;
                  }}
                />
              </Grid>
            </Grid>

            {/* Right column - Person related fields */}
            <Grid container item xs={12} sm={6} spacing={2}>
              <Grid item xs={12}>
                <FormControl
                  fullWidth
                  size="small"
                  variant="outlined"
                  error={Boolean(errors.general.BusinessNature)}
                >
                  <InputLabel>Business Groups</InputLabel>
                  <Select
                    name="BusinessGroup"
                    value={nodeData.BusinessGroup}
                    onChange={handleChange}
                    label="Business Groups"
                  >
                    {groups?.map((item, index) => {
                      return (
                        <MenuItem key={index} value={item._id}>
                          {item.businessNature?.charAt(0)?.toUpperCase() +
                            item.businessNature?.slice(1)}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  {errors.general.BusinessGroup && (
                    <small style={{ color: "red" }}>
                      {errors.general.BusinessGroup}
                    </small>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Managing Director"
                  name="ManagingDirector"
                  id="outlined-basic"
                  value={nodeData.ManagingDirector}
                  onChange={handleChange}
                  error={Boolean(errors.general.ManagingDirector)}
                  fullWidth
                  helperText={errors.general.ManagingDirector}
                  variant="outlined"
                  size="small"
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Deputy Managing Director"
                  name="DeputyManagingDirector"
                  id="outlined-basic"
                  value={nodeData.DeputyManagingDirector}
                  onChange={handleChange}
                  error={Boolean(errors.general.DeputyManagingDirector)}
                  fullWidth
                  helperText={errors.general.DeputyManagingDirector}
                  variant="outlined"
                  size="small"
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Chairman"
                  name="Chairman"
                  id="outlined-basic"
                  value={nodeData.Chairman}
                  onChange={handleChange}
                  error={Boolean(errors.general.Chairman)}
                  fullWidth
                  helperText={errors.general.Chairman}
                  variant="outlined"
                  size="small"
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Deputy Chairman"
                  name="DeputyChairman"
                  id="outlined-basic"
                  value={nodeData.DeputyChairman}
                  onChange={handleChange}
                  error={Boolean(errors.general.DeputyChairman)}
                  fullWidth
                  helperText={errors.general.DeputyChairman}
                  variant="outlined"
                  size="small"
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Company Secretary"
                  name="CompanySecretary"
                  id="outlined-basic"
                  value={nodeData.CompanySecretary}
                  onChange={handleChange}
                  error={Boolean(errors.general.CompanySecretary)}
                  fullWidth
                  helperText={errors.general.CompanySecretary}
                  variant="outlined"
                  size="small"
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Statutory Auditor"
                  name="StatutoryAuditor"
                  id="outlined-basic"
                  value={nodeData.StatutoryAuditor}
                  onChange={handleChange}
                  error={Boolean(errors.general.StatutoryAuditor)}
                  fullWidth
                  helperText={errors.general.StatutoryAuditor}
                  variant="outlined"
                  size="small"
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Representative Director"
                  name="RepresentativeDirector"
                  id="outlined-basic"
                  value={nodeData.RepresentativeDirector}
                  onChange={handleChange}
                  error={Boolean(errors.general.RepresentativeDirector)}
                  fullWidth
                  helperText={errors.general.RepresentativeDirector}
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Resident Director"
                  name="ResidentDirector"
                  id="outlined-basic"
                  value={nodeData.ResidentDirector}
                  onChange={handleChange}
                  error={Boolean(errors.general.ResidentDirector)}
                  fullWidth
                  helperText={errors.general.ResidentDirector}
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Legal Representative"
                  name="LegalRepresentative"
                  id="outlined-basic"
                  value={nodeData.LegalRepresentative}
                  onChange={handleChange}
                  error={Boolean(errors.general.LegalRepresentative)}
                  fullWidth
                  helperText={errors.general.LegalRepresentative}
                  variant="outlined"
                  size="small"
                />
              </Grid>

              {nodeData.directors &&
                nodeData.directors?.map((dir, index) => (
                  <Grid
                    item
                    xs={12}
                    key={index}
                    sx={{ display: "flex", justifyContent: "start" }}
                  >
                    <TextField
                      label="Director"
                      variant="outlined"
                      value={dir}
                      name="Director"
                      onChange={(e) => handelDirector(index, e.target.value)}
                      fullWidth
                      // error={Boolean(errors.directors[index])}
                      // helperText={errors.directors[index]}
                      size="small"
                    />
                    {index !== 0 && (
                      <DeleteIcon
                        style={{
                          fontSize: "30px",
                          color: "#1976d2",
                          cursor: "pointer",
                        }}
                        onClick={() => deleteDirectors(index)}
                      />
                    )}
                  </Grid>
                ))}
            </Grid>
            {origin !== "root" ? (
              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={nodeData.checked}
                      onChange={handleCheck}
                      name="checked"
                      color="primary"
                    />
                  }
                  label="Status: Incorporate In Progress/To be Liquidated"
                />
              </Grid>
            ) : (
              <></>
            )}

            {origin !== "root" ? (
              <Grid item xs={12} sm={6}>
                <Grid item>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={nodeData?.isJointVentureCompany}
                        onChange={handleCheckbox}
                        name="isJointVentureCompany"
                        color="primary"
                      />
                    }
                    label="Joint Venture Company"
                  />
                </Grid>
              </Grid>
            ) : (
              <></>
            )}

            {nodeData?.isJointVentureCompany === true && origin !== "root" && (
              <>
                {nodeData.JointVentureCompanies?.map((shareholder, index) => (
                  <Grid
                    container
                    spacing={1}
                    key={index}
                    style={{ marginTop: "5px", marginLeft: "8px" }}
                    alignItems="center"
                  >
                    <Grid item xs={12} sm={3}>
                      <TextField
                        label="Company Name"
                        size="small"
                        variant="outlined"
                        type="text"
                        value={shareholder?.companyName}
                        onChange={(e) => {
                          handleJointChange(
                            index,
                            "companyName",
                            e.target.value
                          );
                        }}
                        fullWidth
                        error={Boolean(
                          errors?.JointVentureCompanies[index]?.companyName
                        )}
                        helperText={
                          errors?.JointVentureCompanies[index]?.companyName
                        }
                      />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <NumericFormat
                        label="Number of Shares Owned"
                        size="small"
                        variant="outlined"
                        customInput={TextField}
                        thousandSeparator
                        value={shareholder.numberSharesOwned}
                        onValueChange={(values) => {
                          let value = parseFloat(values.value) || 0;

                          // Calculate the total allocated shares between shareholders and joint venture companies
                          let totalAllocatedShares =
                            nodeData.shareHolders.reduce(
                              (acc, item) =>
                                acc + parseFloat(item.numberSharesOwned || 0),
                              0
                            ) +
                            nodeData.JointVentureCompanies.reduce(
                              (acc, item, i) =>
                                i !== index
                                  ? acc +
                                  parseFloat(item.numberSharesOwned || 0)
                                  : acc,
                              0
                            );

                          // Maximum allowed shares for the current joint venture company
                          let maxAllowed =
                            nodeData.totalNoOfShares - totalAllocatedShares;

                          // If the entered value exceeds the allowed limit, set it to the max allowed
                          if (value > maxAllowed) {
                            value = maxAllowed;
                          }

                          // Update the state with the validated number of shares
                          handleJointChange(index, "numberSharesOwned", value);
                        }}
                        fullWidth
                        error={Boolean(
                          errors?.JointVentureCompanies[index]
                            ?.numberSharesOwned
                        )}
                        helperText={
                          errors?.JointVentureCompanies[index]
                            ?.numberSharesOwned
                        }
                        isAllowed={(values) => {
                          const { floatValue } = values;
                          if (floatValue === undefined) return true;
                          if (floatValue < 0) return false;

                          // Calculate max allowed shares
                          let totalAllocatedShares =
                            nodeData.shareHolders.reduce(
                              (acc, item) =>
                                acc + parseFloat(item.numberSharesOwned || 0),
                              0
                            ) +
                            nodeData.JointVentureCompanies.reduce(
                              (acc, item, i) =>
                                i !== index
                                  ? acc +
                                  parseFloat(item.numberSharesOwned || 0)
                                  : acc,
                              0
                            );
                          let maxAllowed =
                            nodeData.totalNoOfShares - totalAllocatedShares;
                          handleJointChange(
                            index,
                            "numberSharesOwned",
                            maxAllowed
                          );

                          return floatValue <= maxAllowed;
                        }}
                      />
                    </Grid>

                    <Grid item xs={8} sm={4}>
                      <TextField
                        label="Percentage of Shares"
                        variant="outlined"
                        size="small"
                        type="text"
                        name="PercentageOfShares"
                        value={
                          parseFloat(shareholder.PercentageOfShares).toFixed(
                            2
                          ) + "%"
                        }
                        disabled
                        fullWidth
                      />
                    </Grid>

                    <Grid item xs={4} sm={1}>
                      <DeleteIcon
                        style={{
                          fontSize: "30px",
                          color: "#1976d2",
                          cursor: "pointer",
                        }}
                        onClick={() => deleteJoint(index)}
                      />
                    </Grid>
                  </Grid>
                ))}
              </>
            )}

            {nodeData?.isJointVentureCompany === true && (
              <Grid item xs={12}>
                <Button
                  sx={{ mr: 1 }}
                  variant="contained"
                  color="primary"
                  size="medium"
                  endIcon={<AddIcon />}
                  onClick={handleAddShareCompany}
                  disabled={sharedata === 0}
                >
                  Add Company
                </Button>
              </Grid>
            )}
            <Grid
              item
              xs={12}
              container
              className="d-flex justify-content-between"
              alignItems="center"
            >
              {/* Checkbox for Operating Companies */}
              <Grid item>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={nodeData.isOperatingCompany} // replace with your state variable
                      onChange={handleCheckboxChange} // replace with your change handler
                      name="isOperatingCompany"
                      color="primary"
                    />
                  }
                  label="Operating Company"
                />
              </Grid>

              {/* Add Director Button */}
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  size="medium"
                  endIcon={<AddIcon />}
                  onClick={handleAddDirector}
                >
                  Add Director
                </Button>
              </Grid>
            </Grid>
            <Grid sx={{ marginTop: "10px", marginBottom: "10px" }} item xs={12}>
              <AddAdditionalFields
                nodeData={nodeData}
                setNodeData={setNodeData}
                errors={errors}
              />
            </Grid>

            <Grid item xs={12} container sx={{ mb: 8 }}>
              <ReactQuill
                value={nodeData.Remarks || ""} // Bind value to state, ensure it's a string
                onChange={handleRemarksChange} // Update state on change
                modules={{
                  toolbar: [
                    // Headers and font size
                    [
                      { header: "1" },
                      { header: "2" },
                      { font: [] },
                      { size: [] },
                    ],
                    // Text formatting
                    ["bold", "italic", "underline", "strike", "blockquote"],
                    // Lists and alignment
                    [{ list: "ordered" }, { list: "bullet" }, { align: [] }],
                    // Color and background color
                    [{ color: [] }, { background: [] }],
                    // Links and clear formatting
                    ["link"],
                    ["clean"], // Clear formatting
                  ],
                }}
                placeholder="Enter remarks here..."
                style={{
                  width: "100%", // Takes full width of the container
                  height: "200px", // Custom height
                }}
              />
            </Grid>
            {origin === "parent" &&
              nodeData.shareHolders?.map((shareholder, index) => (
                <Grid
                  container
                  spacing={1}
                  key={index}
                  sx={{ padding: "0px", marginLeft: "10px" }}
                  style={{ marginTop: "1rem" }}
                  alignItems="center"
                >
                  {/* Autocomplete for selecting a shareholder */}
                  <Grid item xs={12} sm={3}>
                    <Autocomplete
                      id="combo-box-demo"
                      options={(() => {
                        // Get all selected company IDs from other rows (excluding current row)
                        const selectedIds = nodeData.shareHolders
                          ?.map((sh, idx) => (idx !== index) ? sh.childId : null)
                          .filter(Boolean) || [];

                          const jointVentureIds = nodeData.JointVentureCompanies
                          ?.map((jv) =>  jv.childid)
                          .filter(Boolean) || [];
                        const allIds = [...selectedIds, ...jointVentureIds, nodeData?._id?.toString()];
                        // Filter parent options to exclude already selected companies
                        return parentOptions.filter(
                          (item) => !allIds.includes(item.value)
                        );
                      })()}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Shareholder"
                          size="small"
                          variant="outlined"
                          fullWidth
                          error={Boolean(errors.shareholders[index]?.childId)}
                          helperText={errors.shareholders[index]?.childId}
                        />
                      )}
                      value={
                        parent.find(
                          (item) => item.value === shareholder.childId
                        ) || null
                      }
                      onChange={(e, newValue) =>
                        handleShareHolderChange(
                          index,
                          "childId",
                          newValue ? newValue.value : ""
                        )
                      }
                      getOptionLabel={(option) => option.label}
                      isOptionEqualToValue={(option, value) =>
                        option.value === value
                      }
                      renderOption={(props, option) => (
                        <li {...props} key={option.value}>
                          {option.label}
                        </li>
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <NumericFormat
                      label="Number of Ordinary Shares Owned"
                      size="small"
                      variant="outlined"
                      customInput={TextField}
                      thousandSeparator
                      value={shareholder.numberSharesOwned}
                      onValueChange={(values) => {
                        let value = parseFloat(values.value) || 0;

                        // Calculate total allocated shares from shareholders and joint venture companies
                        let totalAllocatedShares =
                          nodeData.shareHolders.reduce(
                            (acc, item, i) =>
                              i !== index
                                ? acc + parseFloat(item.numberSharesOwned || 0)
                                : acc,
                            0
                          ) +
                          nodeData.JointVentureCompanies.reduce(
                            (acc, item) =>
                              acc + parseFloat(item.numberSharesOwned || 0),
                            0
                          );

                        // Calculate the maximum allowed shares
                        let maxAllowed =
                          nodeData.totalNoOfShares - totalAllocatedShares;

                        // If the entered value exceeds the max allowed, set it to the maximum allowed
                        if (value > maxAllowed) {
                          value = maxAllowed;
                        }

                        // Update the state with the validated number of shares
                        handleShareHolderChange(
                          index,
                          "numberSharesOwned",
                          value
                        );
                      }}
                      fullWidth
                      error={Boolean(
                        errors.shareholders[index]?.numberSharesOwned
                      )}
                      helperText={errors.shareholders[index]?.numberSharesOwned}
                      isAllowed={(values) => {
                        const { floatValue } = values;
                        if (floatValue === undefined) return true;
                        if (floatValue < 0) return false;

                        // Calculate max allowed shares
                        let totalAllocatedShares =
                          nodeData.shareHolders.reduce(
                            (acc, item, i) =>
                              i !== index
                                ? acc + parseFloat(item.numberSharesOwned || 0)
                                : acc,
                            0
                          ) +
                          nodeData.JointVentureCompanies.reduce(
                            (acc, item) =>
                              acc + parseFloat(item.numberSharesOwned || 0),
                            0
                          );
                        let maxAllowed =
                          nodeData.totalNoOfShares - totalAllocatedShares;
                        handleShareHolderChange(
                          index,
                          "numberSharesOwned",
                          maxAllowed
                        );

                        return floatValue <= maxAllowed;
                      }}
                    />
                  </Grid>

                  {/* TextField for showing the percentage of shares */}
                  <Grid item xs={8} sm={4}>
                    <TextField
                      label="Percentage of Ordinary Shares"
                      variant="outlined"
                      type="text"
                      value={shareholder.PercentageOfShares.toFixed(2) + "%"}
                      disabled
                      fullWidth
                      size="small"
                    />
                  </Grid>

                  {/* Delete Icon to remove the shareholder */}
                  <Grid item xs={4} sm={1}>
                    <DeleteIcon
                      style={{
                        fontSize: "30px",
                        color: "#1976d2",
                        cursor: "pointer",
                      }}
                      onClick={() => deleteShareholder(index)}
                    />
                  </Grid>
                  {nodeData?.totalIssuedPreferenceShares > 0 && (
                    <>
                      <Grid item xs={12} sm={4}>
                        <NumericFormat
                          value={
                            parseFloat(shareholder.numberofpreferenceshares) ||
                            0
                          }
                          thousandSeparator
                          customInput={TextField}
                          label="Number of Preference Shares Owned"
                          size="small"
                          variant="outlined"
                          fullWidth
                          error={Boolean(
                            errors.shareholders[index]?.numberofpreferenceshares
                          )}
                          helperText={
                            errors.shareholders[index]?.numberofpreferenceshares
                          }
                          onValueChange={(values) => {
                            let value = parseFloat(values.value) || 0;

                            // Calculate the total shares already allocated to other shareholders
                            let totalAllocatedShares =
                              nodeData.shareHolders.reduce(
                                (acc, item, i) =>
                                  i !== index
                                    ? acc +
                                    parseFloat(
                                      item.numberofpreferenceshares || 0
                                    )
                                    : acc,
                                0
                              );

                            // Maximum allowed shares for this shareholder
                            let maxAllowed =
                              nodeData.totalIssuedPreferenceShares -
                              totalAllocatedShares;

                            // If the entered value exceeds the maximum allowed, set it to the max allowed
                            if (value > maxAllowed) {
                              value = maxAllowed;
                            }

                            // Update the state with the validated number of shares
                            handleShareHolderChange(
                              index,
                              "numberofpreferenceshares",
                              value
                            );
                          }}
                          isAllowed={(values) => {
                            const { floatValue } = values;
                            if (floatValue === undefined) return true;
                            if (floatValue < 0) return false;

                            // Calculate max allowed shares
                            let totalAllocatedShares =
                              nodeData.shareHolders.reduce(
                                (acc, item, i) =>
                                  i !== index
                                    ? acc +
                                    parseFloat(
                                      item.numberofpreferenceshares || 0
                                    )
                                    : acc,
                                0
                              );
                            let maxAllowed =
                              nodeData.totalIssuedPreferenceShares -
                              totalAllocatedShares;
                            handleShareHolderChange(
                              index,
                              "numberofpreferenceshares",
                              maxAllowed
                            );

                            return floatValue <= maxAllowed;
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          label="Percentage of Preference Shares"
                          size="small"
                          variant="outlined"
                          type="text"
                          name="PercentageOfShares"
                          value={
                            parseFloat(
                              shareholder.percentageofpreferanceshares
                            ).toFixed(2) + "%"
                          }
                          disabled
                          fullWidth
                          onChange={(e) => {
                            handleShareHolderChange(
                              index,
                              "percentageofpreferanceshares",
                              e.target.value
                            );
                          }}
                          error={Boolean(
                            errors.shareholders[index]
                              ?.percentageofpreferanceshares
                          )}
                          helperText={
                            errors.shareholders[index]
                              ?.percentageofpreferanceshares
                          }
                          inputProps={{ min: 0 }}
                        />
                      </Grid>
                    </>
                  )}
                </Grid>
              ))}

            {origin === "parent" && (
              <Grid
                container
                spacing={2}
                justifyContent="space-between"
                alignItems="center"
                sx={{ padding: "0px", marginTop: "10px" }}
              >
                <Grid item xs={6} sm={6}>
                  <Button
                    sx={{ marginLeft: "20px", marginRight: "8px" }}
                    variant="contained"
                    color="primary"
                    size="medium"
                    endIcon={<AddIcon />}
                    onClick={handelAddShareHolder}
                    disabled={sharedata === 0}
                  >
                    Add ShareHolder
                  </Button>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  container
                  spacing={2}
                  alignItems="center"
                  justifyContent="flex-end"
                  sx={{ padding: "10px" }}
                >
                  <Grid item>
                    <TextField
                      label="Remaining Shares"
                      variant="outlined"
                      value={sharedata
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      fullWidth
                      disabled
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>
            )}

            <Grid item xs={12} container justifyContent="space-between">
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
              >
                Save
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleCancel}
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>

      {showWarningModal && (
        <div
          className="modal-backdrop fade show"
          style={{ zIndex: 1200 }}
          onClick={() => setShowWarningModal(false)}
        />
      )}
      {showWarningModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="warningModalLabel"
          aria-hidden="true"
          style={{ zIndex: 1300 }}
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header text-center">
                <h5 className="text-center" id="warningModalLabel">
                  Warning
                </h5>
              </div>
              <div className="modal-body text-center">
                ALL ENTERED DATA WILL BE DELETED IF YOU CLOSE THIS WINDOW
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowWarningModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleConfirmClose}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}
